import { useRef, useEffect, type MutableRefObject } from 'react';

/**
 * Custom hook that returns a ref that can be used to access the latest version
 * of a callback.
 *
 * See https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * for an explanation about why this is necessary.
 */
export function useSavedCallback<T>(callback: T): MutableRefObject<T> {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return callbackRef;
}
